import StandardModal from '@/components/common/standard.modal';
import ContributorProfileForm from './contributor-profile.form';
import type { ContributorSummaryDto } from '@/types/dtos/contributors/response/contributor-summary.dto';
import type { ContributorDto } from '@/types/dtos/contributors/response/contributor.dto';
import { useTranslations } from '@/i18n/use-translations';
import { useBreakpointUp } from '@/hooks/use-breakpoint';

interface ContributorProfileModalProps {
  open: boolean;
  onClose: () => void;
  contributor: ContributorSummaryDto | ContributorDto;
}

const ContributorProfileModal = ({ open, onClose, contributor }: ContributorProfileModalProps) => {
  const t = useTranslations();
  const isWideScreen = useBreakpointUp('md');

  return (
    <StandardModal
      open={open}
      close={onClose}
      title={t('myEventsList.contributorProfileForm.title')}
      subtitle={t('myEventsList.contributorProfileForm.description')}
      size="lg"
      height={isWideScreen ? '700px' : '500px'}
      maxHeight={isWideScreen ? 'calc(100vh - 64px)' : 'calc(100vh - 32px)'}
      width={isWideScreen ? '1000px' : undefined}
    >
      <ContributorProfileForm contributor={contributor} alwaysExpanded={true} onClose={onClose} />
    </StandardModal>
  );
};

export default ContributorProfileModal;
